import { render, staticRenderFns } from "./HomeSixChallenges.vue?vue&type=template&id=6661701d"
import script from "./HomeSixChallenges.vue?vue&type=script&lang=ts"
export * from "./HomeSixChallenges.vue?vue&type=script&lang=ts"
import style0 from "./HomeSixChallenges.vue?vue&type=style&index=0&id=6661701d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports